import { render } from "./Servicerequest.vue?vue&type=template&id=3eb8cb3a&scoped=true"
import script from "./Servicerequest.vue?vue&type=script&lang=js"
export * from "./Servicerequest.vue?vue&type=script&lang=js"

import "./Servicerequest.vue?vue&type=style&index=0&id=3eb8cb3a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb8cb3a"]])

export default __exports__